<vdw-tag [value]="'ORDERBOOK.IN_PATH' | bmsTranslate: {pathNumber: pathNumber}" [color]="getColor()"></vdw-tag>
